import { supabase } from '@/lib/supabase';

export const markNotificationsAsRead = async (
  notificationIds: number[],
): Promise<void> => {
  const { error } = await supabase.rpc('mark_notifications_as_read', {
    p_notification_ids: notificationIds,
  });

  if (error) throw error;

  return;
};
